import Layout from "@/components/Layout";
import { PageHero, useHasPageOverride } from "@/hooks/usePageContent";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function About() {
  const override = useHasPageOverride("about");
  const settings = useSiteSettings();
  const size = settings.collection_goal || 52;
  return (
    <Layout>
      <PageHero slug="about" />
      {!override && (
      <section className="bg-black pt-24 pb-24">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <h1 className="text-grunge text-5xl md:text-7xl text-[#F5F2EB] leading-[0.95] mb-10">SIMPLE OBJECTS.<br/>PROFOUND TRUTHS.</h1>

          <div className="grid md:grid-cols-3 gap-12">
            <div className="md:col-span-2 font-body text-lg text-[#F5F2EB] space-y-6 leading-relaxed">
              <p>The Simple Truths Collection is a growing body of work — {size} pieces, one truth at a time. Each piece begins with a simple object: a rope, a match, an anchor, a key. Each one carries a meaning worth keeping.</p>
              <p>I make art for the people still climbing. The people who need a reminder more than they need a decoration. The kind of art you don’t hang to fill a wall — you hang it to remember.</p>
              <p>This isn’t just a print shop. It’s a mobile gallery, a story-driven collection, and a movement built around the small truths that change the way we walk through the day.</p>
              <p className="font-script text-3xl text-[#D4B07B]">— Mickey Trivett</p>
            </div>
            <aside className="border border-white/10 p-6 bg-[#0a0a0a] h-fit">
              <div className="font-ui text-[10px] tracking-[0.32em] text-[#B8915A] uppercase mb-3">The Promise</div>
              <ul className="space-y-3 font-body text-[#F5F2EB]">
                <li>· {size} pieces in the collection</li>
                <li>· Each piece, its own story</li>
                <li>· Premium fine-art prints</li>
                <li>· Made to last. Meaningful always.</li>
              </ul>
            </aside>
          </div>
        </div>
      </section>
      )}
    </Layout>
  );
}
